import { SnapshotEventsDashboard } from "@/modules/snapshots/snapshotEvents/snapshotEventsDashboard";
import { useGetSnapshotEventsQuery } from "@/modules/snapshots/businessReports.api";
import React from "react";
import { useSearchParams } from "react-router";

export const SnapshotEventsView: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [businessReportOutcomeId = undefined] = searchParams.getAll("businessReportOutcomeId");
  const [documentName = undefined] = searchParams.getAll("documentName");

  const { data, isLoading, isSuccess, isError } = useGetSnapshotEventsQuery({
    businessReportOutcomeId,
    documentName,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError || !isSuccess) {
    return <div>Error</div>;
  }

  return <SnapshotEventsDashboard events={data} />;
};
